

<mat-sidenav-container class="h-screen" style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);">
  <!-- Sidebar -->
  <mat-sidenav
    mode="side"
    opened
    class="bg-gray-900 text-white w-64 md:w-56 sm:w-52 h-full flex flex-col justify-between"
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
  >
    <div class="flex justify-center items-center p-4 bg-white">
      <img
        src="assets/puma-logo.png"
        alt="PUMA Logo"
        class="w-48 sm:w-40 xl:w-56"
      />
    </div>

    <span
      class="text-base flex items-center justify-center text-black pr-3 qqmeTxt_2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        class="pr-3"
      >
        <path
          d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
          fill="var(--app-heading)"
        />
      </svg>
      213.947.0000
    </span>
  </mat-sidenav>

  <mat-sidenav-content style="background-color: var(--app-canvas)">
    <mat-toolbar
      style="background-color: #ffffff"
      class="flex justify-center items-center h-24"
    >
      <div class="flex flex-col text-center">
        <h2 class="title m-0 font-medium text-2xl">
          Update applicant phone number
        </h2>
      </div>
    </mat-toolbar>

    <div>
      <!-- <mat-spinner [diameter]="40" class="qqmeBtn" *ngIf="isLoading"></mat-spinner> -->

      <div
        class="p-gutter h-full vexContainer overflow-hidden bg-[var(--app-canvas)]"
        *ngIf="!isLoading"
        style="border-radius: 12px !important"
      >
        <div class="px-24 py-3" style="background-color: #ebf8ff; border-top-right-radius: 12px; border-top-left-radius: 12px;">
          <div>
            <!-- <strong>Applicant Name:</strong> -->
            <span class="text-lg font-medium" style="color: var(--app-heading)">{{
              applicantName
            }}</span>
          </div>
          <div>
            <!-- <strong>Applicant ID:</strong> -->
            <span class="text-base" style="color: #516685">{{ gender }}</span>
          </div>
        </div>
        <div class="card h-auto min-h-full" style="border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
          <div class="px-24 py-4" fxLayout="column">
            <form
              [formGroup]="myForm"
             
              class="phone-form flex flex-col gap-6"
            >
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-4 min-w-40">
                  <div
                    class="flex items-center justify-center p-2 rounded-full h-10 w-10"
                    style="background-color: #d3eeff"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="18"
                      viewBox="0 0 24 18"
                      fill="none"
                    >
                      <path
                        d="M9 11C10.65 11 12 9.65 12 8C12 6.35 10.65 5 9 5C7.35 5 6 6.35 6 8C6 9.65 7.35 11 9 11ZM9 7C9.54 7 10 7.46 10 8C10 8.54 9.54 9 9 9C8.46 9 8 8.54 8 8C8 7.46 8.46 7 9 7Z"
                        fill="var(--app-heading)"
                      />
                      <path
                        d="M22 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H22C23.1 18 23.99 17.1 23.99 16L24 2C24 0.9 23.1 0 22 0ZM4.54 16C5.64 14.78 7.23 14 9 14C10.77 14 12.36 14.78 13.46 16H4.54ZM22 16H15.92C14.54 13.61 11.96 12 9 12C6.04 12 3.46 13.61 2.08 16H2V2H22V16Z"
                        fill="var(--app-heading)"
                      />
                      <path
                        d="M15.78 8.15L17.25 7.3V9H18.75V7.3L20.22 8.15L20.97 6.85L19.5 6L20.97 5.15L20.22 3.85L18.75 4.7V3H17.25V4.7L15.78 3.85L15.03 5.15L16.5 6L15.03 6.85L15.78 8.15Z"
                        fill="var(--app-heading)"
                      />
                    </svg>
                  </div>
                  <span class="text-base font-medium" style="color: #516685"
                    >Date of birth</span
                  >
                </div>
                <div class="text-base text-black">{{ (dob | date : "MM/dd/yyyy" : "UTC") }}</div>
              </div>
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-4 min-w-40">
                  <div
                    class="flex items-center justify-center p-2 rounded-full h-10 w-10"
                    style="background-color: #d3eeff"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M1 11V21H7V16H9V21H15V11L8 6L1 11ZM13 19H11V14H5V19H3V12.03L8 8.46L13 12.03V19Z"
                        fill="var(--app-heading)"
                      />
                      <path d="M19 7H17V9H19V7Z" fill="var(--app-heading)" />
                      <path d="M19 11H17V13H19V11Z" fill="var(--app-heading)" />
                      <path d="M19 15H17V17H19V15Z" fill="var(--app-heading)" />
                      <path
                        d="M10 3V4.97L12 6.4V5H21V19H17V21H23V3H10Z"
                        fill="var(--app-heading)"
                      />
                    </svg>
                  </div>
                  <span class="text-base font-medium" style="color: #516685"
                    >Address</span
                  >
                </div>
                <div class="text-base text-black">{{ applicantAddress }}</div>
              </div>
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-4 min-w-40">
                  <div
                    class="flex items-center justify-center p-2 rounded-full h-10 w-10"
                    style="background-color: #d3eeff"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
                        fill="var(--app-heading)"
                      />
                    </svg>
                  </div>
                  <span class="text-base font-medium" style="color: #516685"
                    >Home Phone</span
                  >
                </div>
                <!-- <div class="text-base text-black">{{ applicantAddress }}</div> -->
                <div class="max-w-xxxs">
                  <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>Home Phone</mat-label>
                    <ng-container *ngIf="!isPhoneInput; else phoneInput">
                      <mat-select
                        formControlName="phone"
                        (selectionChange)="onPhoneSelectionChange($event.value)"
                      >
                        <mat-option [value]="noPhoneValue">{{
                          noPhoneLabel
                        }}</mat-option>
                        <mat-option value="Enter Phone">Enter Phone</mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #phoneInput>
                      <div class="phone-input">
                        <input
                          matInput
                          placeholder="Enter Phone Number"
                          formControlName="phone"
                          appPhoneFormatter
                          maxlength="14"
                        />
                        <mat-icon
                          matSuffix
                          (click)="onPhoneSelectionChange(noPhoneValue)"
                          [matTooltip]="noPhoneLabel"
                          class="clickable"
                          >close</mat-icon
                        >
                      </div>
                    </ng-template>
                    <mat-error
                      *ngIf="myForm.get('phone')?.hasError('required')"
                    >
                      Home phone is required
                    </mat-error>
                    <mat-error
                      *ngIf="myForm.get('phone')?.hasError('invalidPhone')"
                    >
                      Invalid format. Use (XXX) XXX-XXXX
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-4 min-w-40">
                  <div
                    class="flex items-center justify-center p-2 rounded-full h-10 w-10"
                    style="background-color: #d3eeff"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
                        fill="var(--app-heading)"
                      />
                    </svg>
                  </div>
                  <span class="text-base font-medium" style="color: #516685"
                    >Cell Phone</span
                  >
                </div>
                <!-- <div class="text-base text-black">{{ applicantAddress }}</div> -->
                <div class="max-w-xxxs">
                  <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>Cell Phone</mat-label>
                    <ng-container *ngIf="!isCellPhoneInput; else cellInput">
                      <mat-select
                        formControlName="altPhone"
                        (selectionChange)="
                          onAltPhoneSelectionChange($event.value)
                        "
                      >
                        <mat-option [value]="noPhoneValue">{{
                          noPhoneLabel
                        }}</mat-option>
                        <mat-option value="Enter Phone">Enter Phone</mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #cellInput>
                      <div class="phone-input">
                        <input
                          matInput
                          placeholder="Enter Phone Number"
                          formControlName="altPhone"
                          appPhoneFormatter
                          maxlength="14"
                        />
                        <mat-icon
                          matSuffix
                          (click)="onAltPhoneSelectionChange(noPhoneValue)"
                          [matTooltip]="noPhoneLabel"
                          class="clickable"
                          >close</mat-icon
                        >
                      </div>
                    </ng-template>
                    <mat-error
                      *ngIf="myForm.get('altPhone')?.hasError('invalidPhone')"
                    >
                      Invalid format. Use (XXX) XXX-XXXX
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-4 min-w-40">
                  <div
                    class="flex items-center justify-center p-2 rounded-full h-10 w-10"
                    style="background-color: #d3eeff"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
                        fill="var(--app-heading)"
                      />
                    </svg>
                  </div>
                  <span class="text-base font-medium" style="color: #516685"
                    >Work Phone</span
                  >
                </div>
                <!-- <div class="text-base text-black">{{ applicantAddress }}</div> -->
                <div class="max-w-xxxs">
                  <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>Work Phone</mat-label>
                    <ng-container *ngIf="!isWorkPhoneInput; else workInput">
                      <mat-select
                        formControlName="workPhone"
                        (selectionChange)="
                          onWorkPhoneSelectionChange($event.value)
                        "
                      >
                        <mat-option [value]="noPhoneValue">{{
                          noPhoneLabel
                        }}</mat-option>
                        <mat-option value="Enter Phone">Enter Phone</mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #workInput>
                      <div class="phone-input">
                        <input
                          matInput
                          placeholder="Enter Phone Number"
                          formControlName="workPhone"
                          appPhoneFormatter
                          maxlength="14"
                        />
                        <mat-icon
                          matSuffix
                          (click)="onWorkPhoneSelectionChange(noPhoneValue)"
                          [matTooltip]="noPhoneLabel"
                          class="clickable"
                          >close</mat-icon
                        >
                      </div>
                    </ng-template>
                    <mat-error
                      *ngIf="myForm.get('workPhone')?.hasError('invalidPhone')"
                    >
                      Invalid format. Use (XXX) XXX-XXXX
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
       <div
         class="p-6 flex justify-end items-center bg-white shadow-md"
         style="background-color: #d0d8e8;"
       >
        <span class="text-lg flex items-center">
          <!-- <mat-icon class="t2 px-2">phone</mat-icon> 213.947.0000 -->
        </span>
        <button
          mat-raised-button
          matTooltip="Submit"
           class="save-draft"
          type="button"
          (click)="onSubmit()"
          [disabled]="myForm.invalid || isLoading"
      
        >
          <div class="button-content">
            <mat-spinner
              *ngIf="isLoading"
              diameter="20"
              strokeWidth="3"
              class="spinner"
            ></mat-spinner>
            <span *ngIf="!isLoading">Submit</span>
          </div>
        </button>
        <!-- <button
          mat-raised-button
          class="save-draft"
          type="button"
          click="onSubmit()"
          matTooltip="Submit"
          type="submit"
          [disabled]="myForm.invalid || isLoading"
        >
          <span *ngIf="!isLoading">Submit</span>
          <span *ngIf="isLoading">
            <mat-spinner diameter="20"></mat-spinner> Submitting...
          </span>
          
        </button> -->
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
